export default {
  element: (state) => state.selectedElement,
  successAction: (state) => state.successAction,
  configSheet: (state) => state.configSheet,
  allDocuments: (state) => Object.values(state.allDocuments || {})
    .filter((document) => document.groupId.includes('.item')),
  workerData: (state) => state.workerData,
  companyProfiles: (state) => state.companyProfiles,
  groupTableFields: (state) => state.groupTableFields,
};
